/*
 * announcementBar — dismissible site-wide announcement band.
 *
 * CSP-safe (name-only x-data + registered Alpine.data). All state derives from
 * the server-rendered DOM: the dismissal key is read from data-announcement-key
 * (a slug of the message), never passed inline. Because the key is content-derived,
 * editing the message produces a new key that no longer matches the stored one, so
 * the bar automatically re-surfaces for everyone who had dismissed the old copy.
 *
 * The bar lives OUTSIDE #swup, so this component initialises once at boot and is
 * never torn down by a Swup navigation — the dismissed state persists for the whole
 * session (and across sessions, via localStorage).
 *
 * No-JS: the bar renders visible server-side and this code never runs, so it simply
 * stays visible (the dismiss button is .js-only).
 */
const STORAGE_KEY = 'psd:announcement-dismissed';

export default function announcementBar() {
    return {
        visible: true,
        messageKey: '',

        init() {
            this.messageKey = this.$el.dataset.announcementKey || '';

            try {
                if (this.messageKey && localStorage.getItem(STORAGE_KEY) === this.messageKey) {
                    this.visible = false;
                }
            } catch (e) {
                // localStorage unavailable (private mode / disabled) — keep the bar shown.
            }
        },

        dismiss() {
            this.visible = false;

            try {
                if (this.messageKey) {
                    localStorage.setItem(STORAGE_KEY, this.messageKey);
                }
            } catch (e) {
                // Non-fatal — the bar still hides for this page view.
            }
        },

        destroy() {},
    };
}
